import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center gap-2 w-100" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-container position-relative col"
}
const _hoisted_3 = { class: "dropdown-container position-relative col" }
const _hoisted_4 = { class: "dropdown-input dropdown border-default bg-primary-white w-100 outline-none caption d-block align-items-center" }
const _hoisted_5 = {
  class: "label",
  style: {"z-index":"1"}
}
const _hoisted_6 = { class: "dropdown-container position-relative col" }
const _hoisted_7 = { class: "dropdown-input dropdown bg-primary-white w-100 outline-none caption d-flex align-items-center" }
const _hoisted_8 = {
  class: "label",
  style: {"z-index":"1"}
}

import FlightOriginDropdown from './flight/flightOriginDropDown.vue'
import DatePickerV2 from '@/vue/planning/components/search/DatePickerV2.vue'
import Participants from '@/vue/planning/components/search/participants.vue'
import transportPackCode from '@/config/transportPackCode'
import { computed } from 'vue'

import { useStore } from 'vuex'

export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopSearchBar',
  setup(__props) {

// Store
// import store from '@/vue/planning/store/store'
const store = useStore()

const content = computed(() => store.state.content)

const isTransportPack = computed(() => transportPackCode.includes(store.state.packCode))

const handleChangeOpenParticipants = (bool: boolean) => {
  store.dispatch('setParticipantsDropdownOpen', bool)
}

const handleSetParticipants = (newArray: Array<unknown>) => {
  store.dispatch('setParticipants', newArray)
}

const handleNotEnoughAdults = () => {
  store.commit('setErrorMessageOpen', 'errorMessages_notEnoughAdults')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isTransportPack.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FlightOriginDropdown)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DatePickerV2)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(content.value.planner_prestationsDates), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Participants, {
          onChangeOpenParticipants: handleChangeOpenParticipants,
          onSetParticipants: handleSetParticipants,
          onNotEnoughAdults: handleNotEnoughAdults
        })
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(content.value.planner_prestationsParticipants), 1)
    ])
  ]))
}
}

})